import { mission } from "../routes";
const createSubmission = async (data) => {
  try {
    const response = await fetch(mission.createRoute, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      const result = await response.json();
      throw new Error("Request failed with status: " + response.status + ", " + result.message);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const updateSubmission = async (data) => {
  try {
    const response = await fetch(mission.updateRoute, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getSubmissionById = async (data) => {
  try {
    const response = await fetch(mission.getSubmissionById, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getSubmission = async (data) => {
  try {
    const response = await fetch(mission.getSubmission, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify({
        ...data,
        event: "minigameVhu30",
      }),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const updateSubmissionStatus = async (data) => {
  try {
    const response = await fetch(mission.updateSubmissionStatus, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const updateSubmissionStatusWithPoints = async (data) => {
  try {
    const response = await fetch(mission.updateStatusWithPoints, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      const result = await response.json();
      throw new Error("Request failed: " + response.status + ", " + result.message);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getSubmissionByLink = async (data) => {
  try {
    const response = await fetch(mission.getSubmissionByLink, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getDashboardStatistics = async (data) => {
  try {
    const response = await fetch(mission.getDashboardStatistics, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ event: data }),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const toggleSubmissionStar = async (data) => {
  try {
    const response = await fetch(mission.toggleSubmissionStar, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
      return null;
    }
  } catch (error) {
    console.error("Error toggling star:", error);
    throw error;
  }
};

const exportLogsExcel = mission.exportLogsExcel;

export {
  createSubmission,
  updateSubmission,
  getSubmissionById,
  getSubmission,
  updateSubmissionStatus,
  updateSubmissionStatusWithPoints,
  getSubmissionByLink,
  getDashboardStatistics,
  toggleSubmissionStar,
  exportLogsExcel,
};
